module.exports = __webpack_public_path__ + "img/2-5.0f536529.png";